import { Avatar, Typography } from "@mui/material"
import createAvatar from "minimals-template/components/utils/createAvatar"

const SIZE = 30

// One overlapping initials circle in a schedule card's commenter stack. Colour and initials are derived
// the same way as every other avatar in the app (`createAvatar`), so a person reads the same wherever
// they appear. A paper-coloured ring separates the overlapping circles. Rendered per commenter via
// `<Repeat pass="commenter">`, so it is a separate file rather than an inline closure.
export function CommentScheduleAvatar({ commenter }) {
    if (!commenter) return null

    const avatar = createAvatar(getDisplayName())

    return (
        <Avatar
            alt={getDisplayName()}
            data-cy="comment-schedule-avatar"
            sx={{
                width: SIZE,
                height: SIZE,
                border: "2px solid",
                borderColor: "background.paper",
                color: "#333",
                backgroundColor: avatar.color,
            }}
        >
            <Typography sx={{ fontSize: 11, fontWeight: 700, lineHeight: 1 }}>{avatar.name}</Typography>
        </Avatar>
    )

    function getDisplayName() {
        return commenter.displayName?.trim() || "Unknown"
    }
}
